import Footer from "../../layout/footer";
import Header from "../../layout/header";
import Builder from "../../component/builder";
import { NextSeo, ArticleJsonLd, BreadcrumbJsonLd } from "next-seo";

function Details({ post }) {
  return (
    <>
      <NextSeo
        title={post.data.site_title}
        description={post.data.meta_description}
        canonical={"https://esmart.sa/page/" + post.data.slug}
      />

      <ArticleJsonLd
        url={"https://esmart.sa/page/" + post.data.slug}
        title={post.data.site_title}
        images={[post.data.image]}
        datePublished={post.data.created_at}
        dateModified={post.data.updated_at}
        authorName={[
          {
            name: "eSmart",
            url: "https://esmart.sa",
          },
        ]}
        publisherName="eSmart"
        publisherLogo="https://esmart.sa/images/favicon.png"
        description={post.data.meta_description}
        isAccessibleForFree={true}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "الرئيسية",
            item: "https://esmart.sa",
          },
          {
            position: 2,
            name: post.data.site_title,
            item: "https://esmart.sa/page/" + post.data.slug,
          },
        ]}
      />
      <Header />
      <div className="page-builder page-content bg-white" id="top">
        {post.data.blcoks.map((item, index) => {
          return <Builder key={index} item={item} />;
        })}
      </div>
      <Footer />
    </>
  );
}

export async function getStaticProps(context) {
  const res = await fetch(
    "https://backend.esmart.sa/api/pages/" + context.params.slug,
    { headers: { "User-Agent": "eSmartWebSite" } }
  );
  if (!res.ok) {
    return {
      redirect: {
        destination: `/500`,
        permanent: false,
      },
    };
  }
  const post = await res.json();

  if (!post.data) {
    return {
      redirect: {
        destination: `/`,
        permanent: false,
      },
    };
  }

  return {
    props: {
      post,
    },
  };
}
export async function getStaticPaths() {
  const res = await fetch("https://backend.esmart.sa/api/pages-sitemap.xml", {
    headers: { "User-Agent": "eSmartWebSite" },
  });
  const posts = await res.json();

  // Get the paths we want to pre-render based on posts
  const paths = posts.data.map((post) => ({
    params: { slug: post.slug },
  }));

  // We'll pre-render only these paths at build time.
  // { fallback: 'blocking' } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths, fallback: "blocking" };
}

export default Details;
